import {Fragment} from 'react'
import classes from './FrontPageQuestionSelectorText.module.css'

const FrontPageQuestionSelectorText = [

  {
    id: "FAQs-Q1",
    question: "Am I eligible for partial retirement?",
    answer: (
      <Fragment>
        <p>
          Partial retirement is available to all pension scheme members who meet the following criteria:
        </p>
        <ul className = {classes.outer_list}>
          <li>You’ve agreed with your employer to reshape your job by reducing your pay by at least 20% (by either reducing your working hours or your pay)</li>
          <li>
          You apply for partial retirement no more than 3 months after reshaping your job
          </li>
          <li>
          You’re over minimum pension age for your pension scheme:
          <ul className = {classes.inner_list}>
              <li>Classic and Classic Plus – 50</li>
              <li>Premium if you joined <b>before</b> 06/04/2006 – 50</li>
              <li>Premium if you joined <b>after</b> 06/04/2006 – 55</li>
              <li>Nuvos – 55</li>
              <li>alpha – 55</li>
          </ul>
          </li>
      </ul>
      <p> If you claim your pension before pension age, it will be reduced for early payment.</p>
      <p> Please note this tool allows for partial retirements from age 55 up to age 75 only.</p>
      </Fragment>
    ),
  },
  {
    id: "FAQs-Q2",
    question: "What is the McCloud Remedy and how does it impact my partial retirement?",
    answer: (
      <Fragment>
      <p> 
          The 2015 Remedy (McCloud) gives you a choice, to be made at the point when you take your benefits. That choice is between your legacy scheme and the alpha scheme for the Remedy Period (1 April 2015 to 31 March 2022). Both schemes offer highly valuable benefits.
      </p>  <p>    
          This illustrator illustrates the comparison of these benefits over the Remedy Period based on a number of assumptions. 
      </p>  <p>
          You will need to make your Remedy choice alongside your partial retirement election if your partial retirement election involves any of the benefits you have built up in the Remedy Period. If your partial retirement is only in respect of alpha benefits built up on or after 1 April 2022, or is in respect of a past deferred award that does not include any Remedy Period service, then a Remedy choice may not be triggered.
      </p>  <p>        
          If a Remedy choice is required, that means there are other factors to take into account when deciding what percentage of your pension benefits to take at partial retirement, as it could affect your tax position, or your final salary link if you have one. If your legacy scheme has a final salary link this means that when you retire your legacy scheme benefits will be based on your final pensionable earnings when you commence pension benefits, and not at the point you transitioned to the alpha scheme. 
      </p>  <p>
          Your Remedy choice will be final and irrevocable at the point you take your partial retirement benefits. 
      </p>
      </Fragment>
    ),
  },
  {
      id: "FAQs-Q3",
      question: "What does this illustrator do?",
      answer: (
        <Fragment>
        <p>
        The illustrator provides an approximate comparison of your salary and pension benefits at both partial retirement and full retirement, based on your inputs and certain assumptions about what happens in the future. It does not allow for all circumstances. The actual salary and pension benefits you receive at partial retirement and full retirement will likely be different to those estimated in this illustrator as they will depend on your actual experience to those dates; for example they may be different when reflecting your actual final pensionable earnings and the actual earnings up to your partial and full retirement dates. In particular, for some legacy schemes in practice your final pensionable earnings are calculated as the highest annual earnings over a number of years before retirement. The calculations in this illustrator do not allow for this level of detail and if you are planning to take a reduction in your full time earnings as part of the partial retirement process, (or have already had a reduction in your full time earnings in the years leading up to partial retirement) then in some cases the illustrator may underestimate your pension benefits. If you intend to take partial retirement, you should discuss your plans with your employer and submit an application at least six months before your proposed commencement date. If your application is approved, Civil Service Pensions will be contacted and will send you a quote. You can find out more here:
        </p> <p>
        < a href="https://www.finance-ni.gov.uk/publications/thinking-about-retirement-booklet" target="blank">https://www.finance-ni.gov.uk/publications/thinking-about-retirement-booklet</a>
        </p> <p>
        This illustrator takes into account abatement which may apply on partial retirement. Further information about abatement can be found here: 
        </p> <p> < a href="https://www.finance-ni.gov.uk/publications/what-abatement" target="blank">https://www.finance-ni.gov.uk/publications/what-abatement</a></p>
        <p>
        The illustrator does not allow for any money purchase Additional Voluntary Contributions (AVCs) or Added Pension benefits which you may have purchased, pension debits, WPS contributions or other special arrangements within the scheme.
        </p> <p>
        This illustrator does not provide illustrations for members in the Nuvos scheme or those who only have service in the alpha scheme.
        </p>
        </Fragment>
      ),
    },
    {
      id: "FAQs-Q4",
      question: "Where will I find the information to complete this illustrator?",
      answer: (
        <Fragment>
            <p> 
          It will be really handy if you have a copy of your latest annual benefit statement available. By clicking <a href = {'https://selfservice.cspensions.finance-ni.gov.uk/' } >this link</a> you can log into the Pension Portal and see it online. Information on your payslip may also assist. For the majority of inputs, if the information is not available then your best estimate is fine.
          </p> <p> 
          We’ll ask you for information including: your date of birth, the date you joined the scheme, your current pensionable earnings and your pensionable earnings at 2015 (the annual amount before tax) and your part-time working history.
          </p> <p>
          Pensionable earnings are the part of your salary used to calculate your regular pension contributions and are also used to calculate your pension entitlement. For many members this is the same as salary, but some members' salaries will also contain non-pensionable allowances. If you are not sure, your salary will provide an approximate illustration. 
          </p>
        </Fragment>
      ),
    },
    {
      id: "FAQs-Q5",
      question: "What are the legacy schemes?",
      answer: (
        <Fragment>
          <p>
          The legacy schemes refer to the Classic, Classic Plus, Premium and Nuvos arrangements. This illustrator does not provide illustrations for members in the Nuvos scheme.
          </p>
        </Fragment>
      ),
    },

    {
      id: "FAQs-Q6",
      question: "How do I apply for partial retirement?",
      answer: (
        <Fragment>
          <p> A step by step guide to partial retirement can be found here:</p>
          <a href = 'https://www.finance-ni.gov.uk/articles/partial-retirement'>
            https://www.finance-ni.gov.uk/articles/partial-retirement
             </a>
        </Fragment>
      ),
    },
  ];
  
  export default FrontPageQuestionSelectorText;